<a
  class="grid grid-cols-12 max-sm:gap-4 bg-white px-4 max-sm:px-2 rounded-6 min-h-[90px] max-sm:min-h-[60px] items-center text-grey-2 font-Roboto-400 text-17 max-sm:text-12 cursor-pointer"
  [routerLink]="[getUrlForMatches()]"
  (click)="$event.preventDefault(); $event.stopPropagation()"
>
  <div
    class="flex items-center justify-between col-span-7 gap-1 max-sm:col-span-7 max-sm:flex-col max-sm:justify-start"
  >
    <div class="flex-1 min-w-0 max-sm:w-full">
      <app-home-team
        [homeTeam]="homeTeamData()"
        [matchStatus]="liveMatch()!.Status"
        [countryName]="teamCountryName()"
        [isWin]="winHomeTeam()"
      />
    </div>
    <app-vs-scores [match]="liveMatch()!" />
    <div class="flex-1 min-w-0 max-sm:w-full">
      <app-away-team
        [awayTeam]="awayTeamData()"
        [matchStatus]="liveMatch()!.Status"
        [countryName]="teamCountryName()"
        [isWin]="winAwayTeam()"
      />
    </div>
  </div>

  <app-status-match
    class="flex items-center justify-center col-span-3 gap-3 font-roboto-500 max-sm:gap-2 max-sm:col-span-2 max-sm:text-10"
    [match]="liveMatch()!"
  />

  <app-icons-resource
    class="flex items-center w-full col-span-2 max-sm:col-span-3 max-sm:justify-end"
    [statusMatch]="liveMatch()!.Status"
    matchId="123"
    [match]="liveMatch()!"
    [urlMatch]="getUrlMatch()"
    tsExternalCompetitionId="tsExternalTeamId()"
    [selectedDate]="selectedDate()"
  />
</a>
